export default class RunningTransactionException extends Error {

}
